import api from './api';

const BASE = '/zelle';

export default {
  list: (params = {}) =>
    api.get(BASE, { params: { functionCode: 'ZELLE_VIEW', ...params } }).then(r => r.data),

  paymentOperators: () =>
    api.get(`${BASE}/payment-operators`, { params: { functionCode: 'ZELLE_VIEW' } }).then(r => r.data),

  get: (id) =>
    api.get(`${BASE}/${id}`, { params: { functionCode: 'ZELLE_VIEW' } }).then(r => r.data),

  create: (data) =>
    api.post(BASE, { ...data, functionCode: 'ZELLE_CREATE' }).then(r => r.data),

  update: (id, data) =>
    api.put(`${BASE}/${id}`, { ...data, functionCode: 'ZELLE_UPDATE' }).then(r => r.data),

  decision: (id, decision) =>
    api.post(`${BASE}/${id}/decision`, { decision, functionCode: 'ZELLE_CONFIRM' }).then(r => r.data),

  pay: (id, payload) =>
    api.post(`${BASE}/${id}/pay`, { ...payload, functionCode: 'ZELLE_PAY' }).then(r => r.data),

  remove: (id) =>
    api.delete(`${BASE}/${id}`, { data: { functionCode: 'ZELLE_DELETE' } }).then(r => r.data),
};
